<template>
    <div>
        <b-tabs :destroy-on-hide="true">
          <b-tab-item label="Manage Tenants">
            <tenant></tenant>
          </b-tab-item>

          <b-tab-item label="Manage Admin Users">
            <admin-user></admin-user>
          </b-tab-item>

          <b-tab-item label="Audit Logs">
            <b-button @click="refreshEvents()" style="margin-left: 5px;"
                          class="button is-success" icon-left="autorenew">Refresh
                </b-button>
                <b-button @click="openBillingEventsPurgeDialog()" style="margin-left: 5px;"
                          class="button is-danger" icon-left="alert-decagram">Purge table
                </b-button>
                <hr/>
                <div class="columns">
                    <div class="column">
                        <b-field label="Search by Game name">
                            <b-input v-model="search_query.name"/>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="Filter by event type">
                            <div class="block">
                                <b-checkbox
                                        v-for="(step, index) in steps"
                                        :key="index"
                                        v-model="search_query.events"
                                        :native-value="step">
                                    {{ step }}
                                </b-checkbox>
                            </div>
                        </b-field>
                    </div>
                </div>

                <b-table
                        :data="filter"
                        :loading="isLoading"
                        :default-sort="['date', 'desc']"
                        :striped="true"
                        :hoverable="true">
                    <template slot-scope="props">
                        <b-table-column class="centered-table-content" field="tenantId" label="Tenant Code">
                            {{ props.row.tenantId }}
                        </b-table-column>

                        <b-table-column class="centered-table-content" field="gameName" label="Game name" sortable>
                            {{ props.row.gameName }}
                        </b-table-column>

                        <b-table-column class="centered-table-content" field="date" label="Date" sortable>
                            {{ props.row.date }}
                        </b-table-column>

                      <b-table-column class="centered-table-content" field="step" label="Step">
                        {{ props.row.step }}
                      </b-table-column>

                      <b-table-column class="centered-table-content" field="infos" label="Info">
                        {{ props.row.infos }}
                      </b-table-column>
                    </template>
                </b-table>
          </b-tab-item>

          <b-tab-item label="Other" disabled>
          </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
import adminService from '../services/adminService'
import adminHelper from '../helpers/admin-helper'
import displayHelper from '../helpers/display-helper'
import {DialogProgrammatic as Dialog} from 'buefy'
import Tenant from './Tenants'
import AdminUser from './AdminUsers'

const steps = []

export default {
  name: 'Admin',
  components: {AdminUser, Tenant},
  data() {
    return {
      isLoading: false,
      billingEvents: [],
      search_query: {
        name: '',
        events: []
      },
      steps: []
    }
        },
        created() {
            this.isLoading = true
            this.search_query.events = steps
            this.loadBillingEventsList()
        },
        methods: {
            goTo(target) {
                this.$router.push({name: target})
            },
            loadBillingEventsList() {
                const parent = this
                adminService.getBillingEvents()
                    .then(billingEvents => {
                        this.billingEvents = billingEvents
                        this.steps = adminHelper.getAllSteps(this.billingEvents)
                        this.isLoading = false

                    })
                    .catch((err) => {
                        displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
                    })
            },
            openBillingEventsPurgeDialog() {
                Dialog.confirm({
                    message: 'Are you sure you want to purge the table?',
                    onConfirm: () => this.purgeBillingEvents()
                })
            },
            purgeBillingEvents() {
                const parent = this
                this.isLoading = true
                adminService.purgeBillingEvents()
                    .then(() => {
                        displayHelper.displaySuccess(parent, 'Table successfully purged')
                    })
                    .catch((err) => {
                        displayHelper.displayError(parent, 'Error while purging the table: ' + err.message)
                    })
                    .finally(() => {
                        console.log('Purged done')
                        this.billingEvents = []
                        this.loadBillingEventsList()
                    })
            },
            refreshEvents() {
                this.loadBillingEventsList()
            }
        },

        computed: {
            filter: function () {
                // eslint-disable-next-line camelcase
                const name_re = new RegExp(this.search_query.name, 'i')
                const data = []
                for (const i in this.billingEvents) {
                    if (this.billingEvents[i].gameName.match(name_re) &&
                        this.search_query.events.includes(this.billingEvents[i].step)) {
                        data.push(this.billingEvents[i])
                    }
                }
                return data
            }
        }
    }
</script>

<style scoped>

</style>
